import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { HeaderService } from '../../services/header.service';
import { NavigationService } from '../../services/navigation.service';

import { TopComponent } from './top/top.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';

@Component({
  selector: 'header',
  imports: [CommonModule, TopComponent, NavigationBarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnDestroy {
  headerService = inject(HeaderService);
  navigationService = inject(NavigationService);

  isWhiteNav: boolean = false;
  isWhiteNavSub!: Subscription;

  currentLinkSub!: Subscription;

  isSpanishPage: boolean = false;

  constructor() {
    //sub to watch for nav white state changes
    this.isWhiteNavSub = this.headerService.isWhiteNavState.subscribe(
      (white) => (this.isWhiteNav = white)
    );

    //sub to watch url to see if white nav should be changed
    this.currentLinkSub = this.navigationService
      .getCurrentUrl()
      .subscribe((url) => {
        if (url != '/') this.headerService.setWhiteNav(false);
        if (url.includes('/es')) {
          this.isSpanishPage = true;
          this.headerService.setWhiteNav(true);
        } else {
          this.isSpanishPage = false;
        };
      });
  }

  ngOnDestroy(): void {
    //unsub from service
    this.isWhiteNavSub.unsubscribe();

    this.currentLinkSub.unsubscribe();
  }
}
